var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPluvaTractor1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5764_33810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5C4.02938 18.5 0 14.4706 0 9.5C0 4.52938 4.02938 0.5 9 0.5C13.9706 0.5 18 4.52938 18 9.5C18 14.4706 13.9706 18.5 9 18.5Z",
    fill: "#445EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6465 4.8395L10.7063 6.98712C10.8113 7.19975 11.0141 7.3475 11.2489 7.38162L13.6189 7.72587C14.2103 7.81175 14.4461 8.5385 14.0183 8.9555L12.3034 10.6272C12.1335 10.793 12.0559 11.0315 12.096 11.2651L12.501 13.625C12.6019 14.2137 11.9839 14.663 11.4551 14.3847L9.33525 13.2702C9.12525 13.16 8.87438 13.16 8.66438 13.2702L6.5445 14.3847C6.01575 14.6626 5.39775 14.2137 5.49863 13.625L5.90363 11.2647C5.94375 11.0307 5.86613 10.7922 5.69625 10.6269L3.98138 8.95512C3.5535 8.53812 3.78975 7.81137 4.38075 7.7255L6.75075 7.38125C6.9855 7.34712 7.18838 7.19975 7.29338 6.98675L8.35313 4.83912C8.61788 4.30362 9.38213 4.30362 9.6465 4.8395Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5764_33810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluvaTractor1);
export default __webpack_public_path__ + "static/media/pluva_tractor1.f08033533cf23ab94456e13a52fefbd3.svg";
export { ForwardRef as ReactComponent };